<script setup>
import { inject } from 'vue'

const store = inject('store')

</script>

<template>
  <div class="table-responsive">
    <table class="table table-dark table-bordered text-center text-secondary text-uppercase fw-bold">
      <thead>
        <tr>
          <th class="bg-black text-light fs-1" scope="col">
            <span>{{ store.state.features.fee }}</span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="bg-black text-light" scope="col">
            <span class="fs-5">{{ store.state.features.corenum }} {{ store.state.features.coreclass }}</span><br>
            <span class="text-secondary">{{ store.state.features.flexible }}</span>
          </td>
        </tr>
        <tr>
          <td class="bg-black text-light">
            <span class="fs-5">Free 1<sup>st</sup> class</span><br>
            <span class="text-secondary">{{ store.state.features.nocontract }}</span>
          </td>
        </tr>
        <tr>
          <td class="bg-black text-grey fs-5">
            <span>{{ store.state.features.grouplive }}</span>
          </td>
        </tr>
        <tr>
          <td class="bg-black text-grey">
            <span class="fs-5">{{ store.state.features.duration45 }}</span><br>
            <span class="text-secondary">{{ store.state.features.duration15 }}</span>
          </td>
        </tr>
        <tr>
          <td class="bg-black text-grey">
            <span class="fs-5">Contact tutor</span><br>
            <div>
              <span>{{ store.state.tutor.name }}</span><br>
              <span>{{ store.state.brand.email1 }}</span>
              <span class="text-white">{{ store.state.brand.email2 }}</span>
              <span>{{ store.state.brand.email1 }}</span>
              <span class="text-white">{{ store.state.brand.email3 }}</span>
              <span class="text-secondary">{{ store.state.brand.domain }}</span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
